// TabSelfCheckin.js
import React, { useEffect }  from 'react';
import { Row, Col, Form, Switch, Input, InputNumber, Tooltip, Typography } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

const labelWithInfo = (label, tooltip) => (
    <span>
    {label}
        <Tooltip title={tooltip}>
      <InfoCircleOutlined style={{ marginLeft: 8, color: '#999' }} />
    </Tooltip>
  </span>
);

const TabSelfCheckin = ({ showEFN }) => {
    // grab the parent form instance and watch for changes.
    const form = Form.useFormInstance();
    const selectedProgrammePointId = Form.useWatch('SelectedProgrammePointId', form);
    const isPrintingEnabled = Form.useWatch('IsPrintingEnabled', form);

    /* Problem IsCreateLeadEnabled to save - SET for IsCreateLeadEnabled Switch
    useEffect(() => {
        if (!selectedProgrammePointId) {
            form.setFieldsValue({ IsCreateLeadEnabled: false });
        }
    }, [selectedProgrammePointId, form]);
*/
    return (
        <>
            {/* Tab description */}
            <Row style={{ marginBottom: 16 }}>
                <Col span={24}>
                    <Text type="secondary">
                        Configure the behaviour of the autocheck-in process on the devices assigned to this configuration.
                    </Text>
                </Col>
            </Row>

            <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} md={8}>
                    <Form.Item
                        name="ignoreDoubleBadge"
                        valuePropName="checked"
                        label={labelWithInfo(
                            'Ignore Already Printed Badge',
                            'Allows printing a new badge even if the participant already has one printed (bypasses ignoreDoubleBadge rule).'
                        )}
                    >
                        <Switch />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                    <Form.Item
                        name="ignoreBadgeDemandsFullPayment"
                        valuePropName="checked"
                        label={labelWithInfo(
                            'Ignore Full Payment Requirement',
                            'Allows printing the badge even if not all bookings are fully paid (bypasses ignoreBadgeDemandsFullPayment rule).'
                        )}
                    >
                        <Switch />
                    </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8}>
                    <Form.Item
                        name="IsPrintingEnabled"
                        valuePropName="checked"
                        label={labelWithInfo('Printing', 'Enable badge printing at check-in')}
                    >
                        <Switch />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                    {/* Item ONLY for label and layout*/}
                    <Form.Item
                        label={labelWithInfo(
                            'Create Lead',
                            'Create a lead (entry) when the QR code is scanned',
                        )}
                    >
                        <Tooltip
                            title={
                                !selectedProgrammePointId
                                    ? 'Select a Programme Point in order to activate this option.'
                                    : ''
                            }
                            color="#faad14"
                            placement="right"
                        >
                            <span style={{ display: 'inline-block' }}>
                                <Form.Item
                                    name="IsCreateLeadEnabled"
                                    valuePropName="checked"
                                    noStyle
                                >
                                  <Switch disabled={!selectedProgrammePointId} />
                                </Form.Item>
                          </span>
                        </Tooltip>
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                    <Form.Item
                        name="IsLottiesAnimationsEnabled"
                        valuePropName="checked"
                        label={labelWithInfo('Animations', 'Show the animations')}
                    >
                        <Switch />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                    <Form.Item
                        name="PrintScreenMilliSeconds"
                        label={labelWithInfo('Printing Screen Milliseconds', 'How long the printing screen stays visible (in ms)')}
                        wrapperCol={{ span: 6 }}
                    >
                        <InputNumber style={{ width: '100%' }} disabled={!isPrintingEnabled} />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                    <Form.Item
                        name="AutoCheckInMilliSeconds"
                        label={labelWithInfo('Delay Milliseconds', 'Time delay before automatic check-in (in ms)')}
                        wrapperCol={{ span: 6 }}
                    >
                        <InputNumber style={{ width: '100%' }} />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                    <Form.Item
                        name="IsShowVersionEnabled"
                        valuePropName="checked"
                        label={labelWithInfo('Show Version', 'Show the app version in the footer of the fullscreen view')}
                    >
                        <Switch />
                    </Form.Item>
                </Col>
                {showEFN && (
                    <Col xs={24} sm={12} md={8}>
                        <Form.Item
                            name="IsEFNCheckEnabled"
                            valuePropName="checked"
                            label={labelWithInfo('Check EFN', 'Enable validation of EFN (German health professionals)')}
                        >
                            <Switch />
                        </Form.Item>
                    </Col>
                )}
            </Row>
        </>
    );
};

export default TabSelfCheckin;